<template>
  <el-empty :description="message"></el-empty>
</template>

<script>
export default {
  watch: {
    $route: {
      handler: function (val) {
        if (val.query) {
          this.message = val.query.message;
        }
      },
      immediate: true,
    },
  },
  data: function () {
    return {
      message: "无权访问",
    };
  },
};
</script>


// WEBPACK FOOTER //
// src/components/noauth.vue